import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InterviewCreationFailedAction = {
	type: 'INTERVIEW_CREATION_FAILED';
	payload: ExtractedMessages;
	/**
	 * Read straight off the HTTP response by the applicative function, never derived from
	 * `extractMessages` — which answers `undefined` for a bodiless error, indistinguishable from a
	 * network failure and unusable to decide a retry.
	 */
	status: number | null;
};

export default (payload: ExtractedMessages, status: number | null): InterviewCreationFailedAction => ({
	type: 'INTERVIEW_CREATION_FAILED',
	payload,
	status,
});
